import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Spinner from "../components/common/Spinner";
import AuthCard from "./AuthCard";
import { resetPassword } from "../api/studioAPI";
import { colors, typography, buttons, form } from "../styles/index";

const MIN_PASSWORD = 8;

// /reset-password?token=... - the emailed link (ForgotPasswordPage): choose a new password, then sign in with it.
export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return undefined;
    setError("");
    if (password.length < MIN_PASSWORD) return setError(`Use at least ${MIN_PASSWORD} characters for the password.`);
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      const out = await resetPassword(token, password);
      navigate("/login", { state: { message: out.msg } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  if (!token) {
    return (
      <AuthCard subtitle="Reset your password">
        <p role="alert" style={form.error}>This reset link is incomplete. <Link to="/forgot-password">Ask for a new one</Link>.</p>
      </AuthCard>
    );
  }

  return (
    <AuthCard subtitle="Choose a new password">
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="password">New password</label>
          <input id="password" type="password" autoComplete="new-password" style={form.input} disabled={loading}
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="confirm">Confirm password</label>
          <input id="confirm" type="password" autoComplete="new-password" style={form.input} disabled={loading}
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        {error && <div style={{ ...form.error, marginBottom: 12 }} role="alert">{error}</div>}
        <button type="submit" disabled={loading} style={{ ...buttons.primary, width: "100%", opacity: loading ? 0.7 : 1 }}>
          {loading ? <><Spinner size={14} /> Saving...</> : "Save new password"}
        </button>
        <p style={{ ...typography.small, marginTop: 20, textAlign: "center", color: colors.textMuted }}>
          Link expired? <Link to="/forgot-password">Ask for a new one</Link>.
        </p>
      </form>
    </AuthCard>
  );
}
